const link_icon = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.02 0C18.634 0.011 24 5.383 24 12C24 18.623 18.624 24 12 24C5.377 24 0 18.623 0 12C0 5.383 5.367 0.011 11.981 0H12.02ZM15.714 16H8.287C8.926 20.266 10.529 23 12 23C13.472 23 15.075 20.266 15.714 16ZM22.249 16H16.726C16.3 18.985 15.405 21.402 14.241 22.771C17.91 22.011 20.912 19.421 22.249 16ZM7.275 16H1.751C3.089 19.421 6.091 22.011 9.76 22.771C8.596 21.402 7.701 18.985 7.275 16ZM7.152 9H1.416C1.085 10.166 0.675 12.389 1.416 15H7.152C6.964 13.186 6.937 11.075 7.152 9ZM15.843 9H8.158C7.963 10.8 7.933 12.927 8.158 15H15.843C16.039 13.189 16.067 11.07 15.843 9ZM22.585 9H16.849C16.911 9.592 17.157 12.019 16.849 15H22.585C23.326 12.388 22.916 10.165 22.585 9ZM9.76 1.229C6.091 1.989 3.089 4.579 1.751 8H7.275C7.701 5.015 8.596 2.597 9.76 1.229ZM15.714 8C15.075 3.734 13.472 1 12 1C10.529 1 8.926 3.734 8.287 8H15.714ZM14.241 1.229C15.405 2.597 16.3 5.015 16.726 8H22.249C20.912 4.579 17.91 1.989 14.241 1.229Z" fill="black"/>
</svg>`;

let map;
const worker = new Worker(workerUrl);
const x_center = 13.405;
const y_center = 52.52;
const listings = document.getElementById("listings");
listings.addEventListener("click", function (e) {
  const featureId = e.target.id.substring(5);
  const [feature] = data.features.filter(
    (feature) => feature.properties.id === featureId,
  );
  if (!feature || !feature.geometry) {
    return;
  }
  flyToStore(feature);
  createPopUp(feature);
  const activeItem = document.getElementsByClassName("active");
  if (activeItem[0]) {
    activeItem[0].classList.remove("active");
  }
  this.parentNode.parentNode.classList.add("active");
});

function buildLocationList(features) {
  listings.innerHTML = "";

  for (const feature of features) {
    /* Add a new listing section to the sidebar. */
    const listingContainer = listings.appendChild(
      document.createElement("div"),
    );
    listingContainer.className = "listing-container";
    const listing = listingContainer.appendChild(document.createElement("div"));
    /* Assign a unique `id` to the listing. */
    listing.id = `listing-${feature.properties.id}`;
    /* Assign the `item` class to each listing for styling. */
    listing.className = "item";

    /* Add the link to the individual listing created above. */
    const link = listing.appendChild(document.createElement("a"));
    //link.href = '#';
    //link.className = 'title';
    link.id = `link-${feature.properties.id}`;
    link.innerHTML = `<span class="title">${feature.properties.name}</span>`;

    /* Add details to the individual listing. */
    const details = link.appendChild(document.createElement("div"));
    details.innerHTML = `<div class="store-address__detail street">${feature.properties.street}</div>`;
    details.innerHTML += `<div class="store-address__detail zip">${feature.properties.zip}</div>`;
    details.innerHTML += `<div class="store-address__detail country">${feature.properties.country}</div>`;
    details.classList.add("store-address");

    const iconsContainer = document.createElement("div");
    iconsContainer.className = "icons-container";

    if (feature.properties.link) {
      const linkIconAnchor = document.createElement("a");
      linkIconAnchor.href = feature.properties.link;
      linkIconAnchor.target = "_blank";

      linkIconAnchor.innerHTML = `${link_icon}`;
      iconsContainer.appendChild(linkIconAnchor);
    }

    listingContainer.appendChild(iconsContainer);
  }
}

buildLocationList(data.features);

function initStoresMap() {
  mapboxgl.accessToken =
    "pk.eyJ1Ijoic3RmZm5kdHoiLCJhIjoiY2x0d3Q2c3RnMDJvYzJpcG82dWdqaTBnNCJ9.pW850wSd_1kAMj7BLbxCww";

  map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/light-v11",
    center: [x_center, y_center],
    zoom: 2,
    scrollZoom: true,
    marker: false,
  });

  map.on("load", () => {
    const Factor = 6;
    const baseWidth = 3;
    const baseHeight = 4;
    const img = /* new Image(18, 24); */ new Image(
      baseWidth * Factor,
      baseHeight * Factor,
    );
    img.crossOrigin = "Anonymous";
    img.onload = () => map.addImage("naysMarker", img);

    img.src = markersrc;

    map.addLayer({
      id: "locations",
      type: "symbol",
      source: {
        type: "geojson",
        data: {
          ...data,
          features: data.features.filter((feature) => feature.geometry),
        },
      },
      layout: {
        "icon-image": "naysMarker",
      },
    });
    // map.addControl(new mapboxgl.NavigationControl());

    map.setLayoutProperty("country-label", "text-field", [
      "get",
      `name_${Shopify.locale}`,
    ]);

    map.on("click", "locations", function (e) {
      flyToStore(e.features[0]);
      createPopUp(e.features[0]);
    });
  });
}

function flyToStore(currentFeature) {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 8,
  });
}

function createPopUp(currentFeature) {
  const popUps = document.getElementsByClassName("mapboxgl-popup");
  /** Check if there is already a popup on the map and if so, remove it */
  if (popUps[0]) popUps[0].remove();

  new mapboxgl.Popup({ closeOnClick: true })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(
      `<h6>${currentFeature.properties.name}</h6><span>${currentFeature.properties.street}</span><span>${currentFeature.properties.zip}</span><span>${currentFeature.properties.country}</span>`,
    )
    .addTo(map);
}

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}
const storesFilter = document.getElementById("stores-filter");
storesFilter.addEventListener("keyup", (e) => {
  const value = e.target.value.trim().toLowerCase();
  data.searchText = value;

  worker.postMessage({ data });
  worker.onmessage = function (e) {
    buildLocationList(e.data);
    setMapFilter(e.data);
  };
});

function extractCountries(stores) {
  const countriesString = stores.reduce((acc, feature) => {
    if (acc.includes(feature.properties.country)) {
      return acc;
    }
    return `${acc}, ${feature.properties.country}`;
  }, "");
  const countries = countriesString.substring(2).split(", ").sort();

  const newSelector = document.getElementById("select-dropdown");
  newSelector.innerHTML =
    `<li role="option">
      <input type="radio" id="All" name="country" checked>
      <label for="All"><i></i>All</label>
    </li>` +
    countries
      .map(
        (country) => `
      <li role="option">
        <input type="radio" id="${country}" name="country">
        <label for="${country}"><i></i>${country}</label>
      </li>`,
      )
      .join("");
}
extractCountries(data.features);

function setMapFilter(filteredFeatures = []) {
  map.setFilter("locations", [
    "all",
    /* getFilterByCountry(), */
    getFilterByIds(filteredFeatures),
  ]);
}

function getFilterByIds(filteredFeatures) {
  if (filteredFeatures.length === 0) {
    return false;
  }

  return [
    "match",
    ["get", "id"],
    filteredFeatures.map((feature) => feature.properties.id),
    true,
    false,
  ];
}

function getFilterByCountry() {
  if (data.country === "all") {
    return ["all"];
  }
  return ["==", "country", data.country];
}

const customSelect = document.querySelector(".custom-select");
const selectBtn = document.querySelector(".select-button");

const selectedValue = document.querySelector(".selected-value");
const optionsList = document.querySelectorAll(".select-dropdown li");

// add click event to select button
selectBtn.addEventListener("click", () => {
  // add/remove active class on the container element
  customSelect.classList.toggle("active");
  // update the aria-expanded attribute based on the current state
  selectBtn.setAttribute(
    "aria-expanded",
    selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true",
  );
});

optionsList.forEach((option) => {
  function handler(e) {
    // Click Events
    if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
      selectedValue.textContent = this.children[1].textContent;
      data.country = this.children[1].textContent;
      worker.postMessage({ data });
      worker.onmessage = function (e) {
        buildLocationList(e.data);
        setMapFilter(e.data);
      };
      customSelect.classList.remove("active");
    }
    // Key Events
    if (e.key === "Enter") {
      data.country = this.textContent;
      worker.postMessage({ data });
      worker.onmessage = function (e) {
        buildLocationList(e.data);
        setMapFilter(e.data);
      };
      selectedValue.textContent = this.textContent;
      customSelect.classList.remove("active");
    }
  }

  option.addEventListener("keyup", handler);
  option.addEventListener("click", handler);
});
